import {
  GET_SERVICE_CATEGORIES,
  GET_SERVICE_CATEGORIES_LOADING,
} from "./types";

import ApiRequest from "./ApiRequest";
import Toast from "../components/common/Toast";

// Reads dbo.service_categories. Every signed-in user calls this once - the
// main menu and the route table are both built from the result.
export const getServiceCategories = () => async (dispatch) => {
  dispatch({ type: GET_SERVICE_CATEGORIES_LOADING, payload: true });

  try {
    const res = await ApiRequest.post(`service_categories`);

    // The endpoint answers with an object ({status:"failed"}) rather than an
    // array when the token has expired; treat anything non-array as "no
    // opinion" so the menu stays as it was instead of emptying out.
    if (!Array.isArray(res.data)) {
      dispatch({ type: GET_SERVICE_CATEGORIES_LOADING, payload: false });
      return null;
    }

    const categories = res.data.reduce((acc, row) => {
      acc[String(row.code).toLowerCase()] = Boolean(row.enabled);
      return acc;
    }, {});

    dispatch({ type: GET_SERVICE_CATEGORIES, payload: categories });

    return res.data;
  } catch (err) {
    // A failed lookup must not black out the menu, so leave the store alone.
    dispatch({ type: GET_SERVICE_CATEGORIES_LOADING, payload: false });
    return null;
  }
};

// Admin only - the backend checks the edit_settings rule.
export const updateServiceCategory = (code, enabled) => async (dispatch) => {
  try {
    const res = await ApiRequest.post(
      `update_service_category?code=${encodeURIComponent(
        code
      )}&enabled=${enabled ? "true" : "false"}`
    );

    if (res.data && res.data.status === "success") {
      Toast.fire({ title: "all is good", icon: "success" });
      return true;
    }

    Toast.fire({
      title: (res.data && res.data.reason) || "Something Went Wrong!",
      icon: "error",
    });
    return false;
  } catch (err) {
    Toast.fire({ title: "Something Went Wrong!", icon: "error" });
    return false;
  }
};
